// Download all data as one file, and upload such a file again: the way back that never depends on
// the account or the cloud copy. Used in Settings → Data and Account → Sync.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem } from './ui';
import { notify } from './Dialogs';
import { exportEverything, importBackup } from '../store/backup';
import { exportText, importText } from '../platform/files';

export default function DataFileButtons({ download, upload }: { download: string; upload: string }) {
  const { t } = useTranslation();
  return (
    <>
      <ListItem
        title={download}
        icon="export"
        onPress={async () => {
          if (await exportText(`chefi-backup-${new Date().toISOString().slice(0, 10)}.json`, exportEverything())) notify(t('library.exportSuccess'));
        }}
      />
      <ListItem
        title={upload}
        icon="import"
        onPress={async () => {
          try {
            const text = await importText();
            if (text) notify(t('library.imported', { count: importBackup(text) }));
          } catch (e) {
            notify(t('library.importFailed', { message: (e as Error).message }));
          }
        }}
      />
    </>
  );
}
